<button
  tuiIconButton
  type="button"
  tuiSlot="start"
  [disabled]="$disabled()"
  [attr.aria-disabled]="$disabled()"
  [ngStyle]="{
    height: $size() + 'px',
    width: $size() + 'px',
    'min-width': $size() + 'px',
    'min-height': $size() + 'px',
  }"
  [ngClass]="{
    'cursor-not-allowed! opacity-35': $disabled(),
  }"
  appearance="transparent"
  (click)="click($event)"
>
  @if ($iconName().startsWith('x-icon')) {
    <x-svg-icon
      [ngStyle]="{
        height: $size() + 'px',
        width: $size() + 'px',
      }"
      [ngClass]="$backgroundPrimary() ? 'x-white' : 'x-white-secondary'"
      class="rounded-full x-icon-btn"
      [icon]="$iconName()"
    ></x-svg-icon>
  } @else {
    <tui-icon
      [ngStyle]="{
        height: $size() + 'px',
        width: $size() + 'px',
        'font-size': $iconSize() ? $iconSize() + 'px' : null,
      }"
      [ngClass]="$backgroundPrimary() ? 'x-white' : 'x-white-secondary'"
      class="rounded-full x-icon-btn"
      [icon]="$iconName()"
    ></tui-icon>
  }
</button>
